import { Injectable } from '@angular/core';
import { InMemoryDbService } from 'angular-in-memory-web-api';
import { userMockData } from '.';
import { roleMockData } from './role-mock-data';
import { RoleModel, UserModel } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class InMemoryDataService implements InMemoryDbService {
  createDb() {
    const users: UserModel[] = userMockData;
    const roles: RoleModel[] = roleMockData;

    return { users, roles };
  }
}
